export enum AutoCompleteType {
    Email,
    PhoneNumber
}